import type { Plugin } from 'vue';

export default {
  install: (app) => {
    app.directive('playwright', {
      mounted(el: HTMLElement, binding) {
        // TODO: render testid only in test environment. NOT in production
        el.dataset.testid = binding.value;
      },
    });
  },
} as Plugin;
